"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _classnames = _interopRequireDefault(require("classnames"));
var _browser = _interopRequireDefault(require("../../utils/browser"));
var _utils = require("../Filter/utils");
var _utils2 = require("./utils");
var _FilterOption = _interopRequireDefault(require("./components/FilterOption"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FilterSingle = exports["default"] = /*#__PURE__*/function (_Component) {
  _inherits(FilterSingle, _Component);
  var _super = _createSuper(FilterSingle);
  function FilterSingle(props) {
    var _this;
    _classCallCheck(this, FilterSingle);
    _this = _super.call(this, props);
    _this.onButtonClick = _this.onButtonClick.bind(_assertThisInitialized(_this));
    _this.onClickOutside = _this.onClickOutside.bind(_assertThisInitialized(_this));
    _this.onOptionChange = _this.onOptionChange.bind(_assertThisInitialized(_this));
    var value = props.value;
    var options = (0, _utils2.formatDropdownOptions)(props.options);
    _this.state = {
      open: false,
      options: options,
      value: value
    };
    return _this;
  }
  _createClass(FilterSingle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onClickOutside);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value;
      if (!_lodash["default"].isEqual(value, this.props.value)) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onClickOutside);
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(e) {
      e.preventDefault();
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      if (this.state.open) {
        var path = _browser["default"].getEventPath(e);
        var index = _lodash["default"].findIndex(path, this.filterWrapper);
        if (index < 0) {
          this.setState({
            open: false
          });
        }
      }
    }
  }, {
    key: "onOptionChange",
    value: function onOptionChange(selectedFilter, value) {
      this.props.onFilterChange(selectedFilter, value);
      this.setState({
        value: value,
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        name = _this$props.name,
        uniqIdPrefix = _this$props.uniqIdPrefix;
      var _this$state = this.state,
        options = _this$state.options,
        value = _this$state.value;
      var activeFilter = _lodash["default"].find(options, {
        value: value
      }, (0, _utils2.findFirstOption)(options));
      var optionElements = _lodash["default"].map(this.state.options, function (option) {
        return /*#__PURE__*/_react["default"].createElement(_FilterOption["default"], {
          id: "".concat(uniqIdPrefix).concat(name, "-").concat(option.value),
          isActive: activeFilter.value === option.value,
          key: "".concat(name, "-").concat(option.value),
          name: name,
          onChange: _this2.onOptionChange,
          option: option
        });
      });
      var currentFilter = _lodash["default"].find(this.state.options, {
        value: value
      });
      var filterClass = function filterClass() {
        return (0, _classnames["default"])({
          'ui-filter-single': true
        }, className);
      };
      var filterButtonClass = function filterButtonClass() {
        return (0, _classnames["default"])({
          open: _this2.state.open
        });
      };
      var dropdownClass = function dropdownClass() {
        return (0, _classnames["default"])({
          dropdown: true,
          open: _this2.state.open
        });
      };
      var accessibilityLabel = "".concat(currentFilter.label, " selected, dropdown");
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: filterClass(),
        id: (0, _utils.createFilterId)(name),
        ref: function ref(filterWrapper) {
          _this2.filterWrapper = filterWrapper;
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        role: "listbox",
        onClick: this.onButtonClick,
        className: filterButtonClass(),
        "aria-label": accessibilityLabel
      }, currentFilter.label), /*#__PURE__*/_react["default"].createElement("div", {
        className: dropdownClass()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-filter-single__options"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-filter-options__container"
      }, optionElements))));
    }
  }]);
  return FilterSingle;
}(_react.Component);
FilterSingle.propTypes = {
  /** className for reference */
  className: _propTypes["default"].string,
  /** Current selected filter to display on FilterSingle button (i.e. 'Cases') */
  name: _propTypes["default"].string.isRequired,
  /**
   * @param {object} activeFilter the current filter option (object)
   * @param {string} value string value
   * @public
  */
  onFilterChange: _propTypes["default"].func.isRequired,
  /** Array of filter options objects */
  options: _propTypes["default"].array.isRequired,
  /** FilterSingle value of current selected option */
  value: _propTypes["default"].string.isRequired,
  /** A prefix to prevent ID conflicts when multiple filters share the same option list */
  uniqIdPrefix: _propTypes["default"].string
};
FilterSingle.defaultProps = {
  className: '',
  uniqIdPrefix: ''
};